import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M3.27 3 2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73zM17 10h-4l4-8H7v2.18l8.46 8.46z" /></g>,<defs key="1"></defs>,]
, 'CameraPhotoFlashOffx');
